(function () {
  'use strict';

  function initFaqAccordions(root) {
    var faqs = root.querySelectorAll('[data-n-faq]');
    Array.prototype.forEach.call(faqs, function (faq) {
      if (faq.dataset.nFaqInit === 'true') return;
      faq.dataset.nFaqInit = 'true';
      faq.classList.add('n-faq--js');

      var buttons = faq.querySelectorAll('[data-n-faq-button]');
      Array.prototype.forEach.call(buttons, function (button) {
        var panelId = button.getAttribute('aria-controls');
        var panel = panelId ? faq.querySelector('#' + panelId) : null;
        if (!panel) return;

        panel.style.maxHeight = '0px';

        button.addEventListener('click', function () {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          panel.style.maxHeight = expanded ? '0px' : panel.scrollHeight + 'px';
        });
      });
    });
  }

  function formatMoney(amount) {
    var num = Number(amount);
    if (isNaN(num)) return amount;
    return '$' + num.toFixed(2);
  }

  function syncStickyBar() {
    var activeOpt = document.querySelector('[data-n-buybox] .n-opt--on');
    if (!activeOpt) return;

    var priceEl = activeOpt.querySelector('[data-n-price]');
    var labelEl = activeOpt.querySelector('.n-opt-t');

    Array.prototype.forEach.call(document.querySelectorAll('[data-n-sticky-price]'), function (el) {
      if (priceEl) el.innerHTML = priceEl.innerHTML;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-n-sticky-label]'), function (el) {
      if (labelEl) el.textContent = labelEl.textContent;
    });
  }

  function initPurchaseOptions(root) {
    var boxes = root.querySelectorAll('[data-n-buybox]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.nBuyboxInit === 'true') return;
      box.dataset.nBuyboxInit = 'true';

      var options = box.querySelectorAll('[data-n-opt]');
      var sellingPlanInput = box.querySelector('[data-selling-plan-input]');
      var addButton = box.querySelector('[data-n-addbtn]');
      var perNightEl = box.querySelector('[data-n-per-night]');
      var perNightAmt = perNightEl ? perNightEl.querySelector('[data-n-per-night-amt]') : null;
      var servings = perNightEl ? Number(perNightEl.dataset.nServings) : null;

      var perServingEl = box.querySelector('[data-n-per-serving]');
      var perServingAmt = perServingEl ? perServingEl.querySelector('[data-n-per-serving-amt]') : null;
      var perServingServings = perServingEl ? Number(perServingEl.dataset.nServings) : null;

      function updatePerNight(priceDecimal) {
        if (!perNightAmt || !servings || isNaN(priceDecimal)) return;
        perNightAmt.textContent = formatMoney(priceDecimal / servings);
      }

      function updatePerServing(priceDecimal) {
        if (!perServingAmt || !perServingServings || isNaN(priceDecimal)) return;
        perServingAmt.textContent = formatMoney(priceDecimal / perServingServings);
      }

      function applySelection(selected) {
        Array.prototype.forEach.call(options, function (opt) {
          opt.classList.toggle('n-opt--on', opt === selected);
        });

        var priceAttr = selected.dataset.nPrice;
        if (priceAttr !== undefined) {
          updatePerNight(Number(priceAttr));
          updatePerServing(Number(priceAttr));
        }
        syncStickyBar();

        if (!sellingPlanInput) return;

        if (selected.dataset.nOptType === 'subscribe') {
          var activeFreq = selected.querySelector('[data-n-freq].n-fb--on');
          sellingPlanInput.value = activeFreq ? activeFreq.dataset.nFreq || '' : '';
        } else {
          sellingPlanInput.value = '';
        }
      }

      Array.prototype.forEach.call(options, function (opt) {
        opt.addEventListener('click', function (event) {
          if (event.target.closest('[data-n-freq]')) return;
          applySelection(opt);
        });
      });

      var freqButtons = box.querySelectorAll('[data-n-freq]');
      Array.prototype.forEach.call(freqButtons, function (btn) {
        btn.addEventListener('click', function (event) {
          event.stopPropagation();
          var group = btn.closest('[data-n-freq-group]');
          if (group) {
            Array.prototype.forEach.call(group.querySelectorAll('[data-n-freq]'), function (b) {
              b.classList.remove('n-fb--on');
            });
          }
          btn.classList.add('n-fb--on');

          var parentOpt = btn.closest('[data-n-opt]');
          if (parentOpt && parentOpt.classList.contains('n-opt--on')) {
            if (sellingPlanInput) sellingPlanInput.value = btn.dataset.nFreq || '';
            var freqPriceAttr = btn.dataset.nPrice;
            if (freqPriceAttr !== undefined) {
              updatePerNight(Number(freqPriceAttr));
              updatePerServing(Number(freqPriceAttr));
            }
            syncStickyBar();

            var badgeEl = parentOpt.querySelector('.n-opt-save');
            if (badgeEl && btn.dataset.nBadge !== undefined) {
              badgeEl.textContent = btn.dataset.nBadge;
            }
          }
        });
      });

      if (addButton && addButton.disabled) {
        addButton.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function initGalleryThumbs(root) {
    var galleries = root.querySelectorAll('[data-n-gallery]');
    Array.prototype.forEach.call(galleries, function (gallery) {
      if (gallery.dataset.nGalleryInit === 'true') return;
      gallery.dataset.nGalleryInit = 'true';

      var mainImg = gallery.querySelector('[data-n-gmain] img');
      var thumbs = gallery.querySelectorAll('[data-n-thumb]');
      if (!mainImg || !thumbs.length) return;

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.dataset.nFull;
          var fullSrcset = thumb.dataset.nFullSrcset;
          if (!fullSrc) return;

          mainImg.src = fullSrc;
          if (fullSrcset) mainImg.srcset = fullSrcset;

          Array.prototype.forEach.call(thumbs, function (t) {
            t.classList.toggle('n-gthumb--active', t === thumb);
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  function initVariantPicker(root) {
    var pickers = root.querySelectorAll('[data-n-variants]');
    Array.prototype.forEach.call(pickers, function (picker) {
      if (picker.dataset.nVariantsInit === 'true') return;
      picker.dataset.nVariantsInit = 'true';

      var box = picker.closest('[data-n-buybox]');
      if (!box) return;

      var dataScript = picker.nextElementSibling;
      if (!dataScript || !dataScript.matches('[data-n-variants-json]')) return;

      var variants;
      try {
        variants = JSON.parse(dataScript.textContent);
      } catch (e) {
        return;
      }
      if (!variants || !variants.length) return;

      var idInput = box.querySelector('input[name="id"]');
      var priceEls = box.querySelectorAll('[data-n-price]');
      var addButton = box.querySelector('[data-n-addbtn]');
      var mainImg = box.querySelector('[data-n-gmain] img');
      var optionGroups = picker.querySelectorAll('[data-n-option-index]');

      function currentSelection() {
        return Array.prototype.map.call(optionGroups, function (group) {
          var active = group.querySelector('.n-vbtn--on');
          return active ? active.dataset.value : null;
        });
      }

      function findVariant(selection) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opts = [v.option1, v.option2, v.option3];
          var matches = true;
          for (var j = 0; j < selection.length; j++) {
            if (selection[j] !== null && opts[j] !== selection[j]) {
              matches = false;
              break;
            }
          }
          if (matches) return v;
        }
        return null;
      }

      function applyVariant(variant) {
        if (!variant) return;

        if (idInput) idInput.value = variant.id;

        Array.prototype.forEach.call(priceEls, function (el) {
          el.textContent = formatMoney(variant.price);
        });

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available
            ? addButton.dataset.nAddLabel || addButton.textContent
            : addButton.dataset.nSoldLabel || addButton.textContent;
        }

        if (mainImg && variant.featured_image && variant.featured_image.src) {
          mainImg.src = variant.featured_image.src;
        }
      }

      Array.prototype.forEach.call(picker.querySelectorAll('[data-n-variant-value]'), function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-n-option-index]');
          Array.prototype.forEach.call(group.querySelectorAll('[data-n-variant-value]'), function (b) {
            b.classList.remove('n-vbtn--on');
          });
          btn.classList.add('n-vbtn--on');

          applyVariant(findVariant(currentSelection()));
        });
      });
    });
  }

  function initStickyAtc(root) {
    var bars = root.querySelectorAll('[data-n-sticky-bar]');
    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.dataset.nStickyInit === 'true') return;
      bar.dataset.nStickyInit = 'true';

      var formId = bar.dataset.nStickyTarget;
      var addButton = document.querySelector('[data-n-buybox] [data-n-addbtn]');
      if (!addButton || !('IntersectionObserver' in window)) return;

      syncStickyBar();

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('n-sticky--visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      observer.observe(addButton);

      var submitBtn = bar.querySelector('[data-n-sticky-submit]');
      if (submitBtn) {
        submitBtn.addEventListener('click', function () {
          var form = formId ? document.getElementById(formId) : null;
          if (!form) form = addButton.closest('form');
          if (form && form.requestSubmit) {
            form.requestSubmit();
          } else if (form) {
            form.submit();
          }
        });
      }
    });
  }

  function initMediaGallery(root) {
    var galleries = root.querySelectorAll('[data-n-media-gallery]');
    Array.prototype.forEach.call(galleries, function (gallery) {
      if (gallery.dataset.nMgInit === 'true') return;
      gallery.dataset.nMgInit = 'true';

      var track = gallery.querySelector('[data-n-mg-track]');
      var slides = gallery.querySelectorAll('[data-n-mg-slide]');
      var prevBtn = gallery.querySelector('[data-n-mg-prev]');
      var nextBtn = gallery.querySelector('[data-n-mg-next]');
      if (!track || !slides.length) return;

      function step(dir) {
        var slideWidth = slides[0].getBoundingClientRect().width + 20;
        track.scrollBy({ left: dir * slideWidth, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    });
  }

  function initBundleAdd(root) {
    var buttons = root.querySelectorAll('[data-n-bundle-add]');
    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.nBundleInit === 'true') return;
      btn.dataset.nBundleInit = 'true';

      btn.addEventListener('click', function () {
        var items;
        try {
          items = JSON.parse(btn.dataset.nBundleItems);
        } catch (e) {
          return;
        }

        var errorEl = btn.parentElement.querySelector('[data-n-bundle-error]');
        var originalText = btn.textContent;
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart add failed');
            return res.json();
          })
          .then(function () {
            window.location.href = window.shopUrl ? window.shopUrl + '/cart' : '/cart';
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalText;
            if (errorEl) errorEl.classList.add('n-bun-error--visible');
          });
      });
    });
  }

  function initTierOffer(root) {
    var boxes = root.querySelectorAll('[data-n-tier-offer]');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.nTierInit === 'true') return;
      box.dataset.nTierInit = 'true';

      var form = box.closest('form');
      var idInput = form ? form.querySelector('[data-n-variant-input]') : null;
      var sellingPlanInput = form ? form.querySelector('[data-selling-plan-input]') : null;
      var realPlanId = box.dataset.planId || '';
      var cards = Array.prototype.slice.call(box.querySelectorAll('[data-tier]'));
      var segButtons = box.querySelectorAll('[data-n-mode]');
      var subSegButton = box.querySelector('[data-n-mode="sub"]');
      var segSave = box.querySelector('[data-n-seg-save]');
      var freeShipMin = Number(box.dataset.freeShipMin || 2);
      var ctxEl = box.querySelector('[data-n-tier-ctx]');
      var ulineEl = box.querySelector('[data-n-uline]');
      var atcAmt = form ? form.querySelector('[data-n-atc-amt]') : null;
      var tierMeta = form ? form.querySelector('[data-n-tier-meta]') : null;

      var mode = 'sub';

      function money(n) {
        var num = Number(n);
        if (isNaN(num)) return '$0.00';
        return '$' + num.toFixed(2);
      }

      function canSubscribe(card) {
        return !!realPlanId && card.dataset.noSub !== '1' && card.dataset.sub !== undefined;
      }

      function priceFor(card) {
        var once = Number(card.dataset.once);
        var sub = Number(card.dataset.sub);
        return mode === 'sub' && canSubscribe(card) && !isNaN(sub) && sub > 0 ? sub : once;
      }

      function selectedCard() {
        var on = box.querySelector('[data-tier][data-on="1"]');
        return on || cards[0];
      }

      function setNode(el, on) {
        if (!el) return;
        el.classList.toggle('n-on', !!on);
        var check = el.querySelector('.n-ic-check');
        var lock = el.querySelector('.n-ic-lock');
        if (check) check.hidden = !on;
        if (lock) lock.hidden = !!on;
      }

      function render() {
        var selected = selectedCard();
        if (!selected) return;

        var bottles = Number(selected.dataset.bottles) || 1;
        var servings = Number(selected.dataset.servings) || 1;
        var isStack = selected.dataset.tier === 'stack';
        var total = priceFor(selected);

        var baseline = box.querySelector('[data-tier="single"]');

        cards.forEach(function (card) {
          var on = card === selected;
          card.dataset.on = on ? '1' : '0';

          var cBottles = Number(card.dataset.bottles) || 1;
          var cServings = Number(card.dataset.servings) || 1;
          var cOnce = Number(card.dataset.once);
          var cIsStack = card.dataset.tier === 'stack';
          var cTotal = priceFor(card);

          var btl = card.querySelector('[data-n-btl]');
          var serv = card.querySelector('[data-n-serv]');
          var tot = card.querySelector('[data-n-tot]');
          var was = card.querySelector('.n-tier-c-was');
          var save = card.querySelector('[data-n-save]');

          if (btl) btl.textContent = money(cTotal / cBottles);
          if (serv) serv.textContent = money(cTotal / cServings) + ' per serving' + (cIsStack ? ' · 2 a day' : '');
          if (tot) tot.textContent = money(cTotal);
          if (was) {
            var showWas = mode === 'sub' && canSubscribe(card);
            was.hidden = !showWas;
            was.textContent = money(cOnce);
          }
          if (save) {
            if (baseline && card !== baseline) {
              var baselineTotal = priceFor(baseline);
              var savings = baselineTotal * cBottles - cTotal;
              save.textContent = savings > 0.01 ? 'Save ' + money(savings) : '';
            } else {
              save.textContent = '';
            }
          }
        });

        if (ctxEl) {
          var nightsPerBottle = Math.round(servings / bottles);
          ctxEl.innerHTML = nightsPerBottle + ' nights per bottle &middot; <b>' + money(total / servings) + '</b>/night';
        }

        if (segSave) {
          var best = 0;
          cards.forEach(function (card) {
            var cOnce = Number(card.dataset.once);
            var cSub = Number(card.dataset.sub);
            if (canSubscribe(card) && !isNaN(cSub) && cSub > 0 && cOnce > 0) {
              var pct = (1 - cSub / cOnce) * 100;
              if (pct > best) best = pct;
            }
          });
          segSave.textContent = best > 0 ? 'up to ' + Math.floor(best) + '%' : '';
        }

        var freeShip = bottles >= freeShipMin || isStack;
        var journal = (mode === 'sub' && canSubscribe(selected)) || isStack;
        var both = isStack;
        var shipNode = box.querySelector('[data-n-node="ship"]');
        var journalNode = box.querySelector('[data-n-node="journal"]');
        var bothNode = box.querySelector('[data-n-node="both"]');
        setNode(shipNode, freeShip);
        setNode(journalNode, journal);
        setNode(bothNode, both);
        if (journalNode) journalNode.classList.toggle('n-lit', freeShip && journal);
        if (bothNode) bothNode.classList.toggle('n-lit', journal && both);

        if (ulineEl) {
          if (!freeShip) {
            var duoCard = box.querySelector('[data-tier="duo"]');
            if (duoCard) {
              var duoBottles = Number(duoCard.dataset.bottles) || 1;
              var duoPerBottle = money(priceFor(duoCard) / duoBottles);
              ulineEl.innerHTML = 'Single ships paid. <button type="button" data-n-to-duo>Move to Duo &mdash; ' + duoPerBottle + ' a bottle, delivery free &rarr;</button>';
              var toDuo = ulineEl.querySelector('[data-n-to-duo]');
              if (toDuo) toDuo.addEventListener('click', function () { selectCard(duoCard); });
            } else {
              ulineEl.textContent = '';
            }
          } else if (!journal) {
            ulineEl.innerHTML = 'Subscribe to get the habit journal. <button type="button" data-n-to-sub>Switch to subscribe &rarr;</button>';
            var toSub = ulineEl.querySelector('[data-n-to-sub]');
            if (toSub) toSub.addEventListener('click', function () { setMode('sub'); });
          } else {
            ulineEl.textContent = 'Journal ships once, with your first order. Yours to keep.';
          }
        }

        if (atcAmt) {
          atcAmt.textContent = '—' + money(total) + (mode === 'sub' && canSubscribe(selected) ? ' every month' : '');
        }
        if (tierMeta) {
          if (isStack) {
            tierMeta.textContent = 'GUARD 30 servings · DEEP ' + (servings * 3) + ' capsules, ' + servings + ' servings';
          } else {
            tierMeta.textContent = (servings * 3) + ' capsules · ' + servings + ' servings · ' + servings + ' nights';
          }
        }

        var variantId = selected.dataset.variantId;
        if (idInput && variantId) idInput.value = variantId;

        if (sellingPlanInput) {
          sellingPlanInput.value = (mode === 'sub' && canSubscribe(selected)) ? realPlanId : '';
        }

        if (subSegButton) {
          var subDisabled = !canSubscribe(selected);
          subSegButton.disabled = subDisabled;
          subSegButton.classList.toggle('n-tier-seg-disabled', subDisabled);
        }

        syncStickyBar();
      }

      function selectCard(card) {
        var input = card.querySelector('input[type="radio"]');
        if (input) input.checked = true;
        cards.forEach(function (c) { c.dataset.on = c === card ? '1' : '0'; });
        if (mode === 'sub' && !canSubscribe(card)) {
          mode = 'once';
          Array.prototype.forEach.call(segButtons, function (btn) {
            btn.setAttribute('aria-selected', String(btn.dataset.nMode === mode));
          });
        }
        render();
      }

      function setMode(m) {
        if (m === 'sub' && !canSubscribe(selectedCard())) return;
        mode = m;
        Array.prototype.forEach.call(segButtons, function (btn) {
          btn.setAttribute('aria-selected', String(btn.dataset.nMode === m));
        });
        render();
      }

      cards.forEach(function (card) {
        var input = card.querySelector('input[type="radio"]');
        if (input) {
          input.addEventListener('change', function () { selectCard(card); });
        }
      });

      Array.prototype.forEach.call(segButtons, function (btn) {
        btn.addEventListener('click', function () { setMode(btn.dataset.nMode); });
      });

      render();
    });
  }

  function initAnnouncementBar(root) {
    var bars = root.querySelectorAll('[data-n-announcement]');
    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.dataset.nAnnInit === 'true') return;
      bar.dataset.nAnnInit = 'true';

      var slides = bar.querySelectorAll('[data-n-ann-slide]');
      if (slides.length <= 1) return;

      var current = 0;
      var timer = null;

      function show(index) {
        current = index;
        Array.prototype.forEach.call(slides, function (slide, i) {
          slide.classList.toggle('n-ann-slide--active', i === index);
        });
      }

      function next() {
        show((current + 1) % slides.length);
      }

      function start() {
        timer = window.setInterval(next, 5000);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);

      start();
    });
  }

  function initSmoothScroll(root) {
    var links = root.querySelectorAll('[data-n-scroll-target]');
    Array.prototype.forEach.call(links, function (link) {
      if (link.dataset.nScrollInit === 'true') return;
      link.dataset.nScrollInit = 'true';

      link.addEventListener('click', function (event) {
        var targetId = link.dataset.nScrollTarget;
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initQuoteCarousel(root) {
    var carousels = root.querySelectorAll('[data-n-quotes]');
    Array.prototype.forEach.call(carousels, function (carousel) {
      if (carousel.dataset.nQuotesInit === 'true') return;
      carousel.dataset.nQuotesInit = 'true';

      var slides = carousel.querySelectorAll('[data-n-bq-slide]');
      var dotsWrap = carousel.querySelector('[data-n-bq-dots]');
      if (slides.length <= 1 || !dotsWrap) return;

      var current = 0;
      var timer = null;

      var dots = Array.prototype.map.call(slides, function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'n-bq-dot' + (index === 0 ? ' n-bq-dot--active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Show quote ' + (index + 1));
        dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          show(index);
          restart();
        });
        dotsWrap.appendChild(dot);
        return dot;
      });

      function show(index) {
        current = index;
        Array.prototype.forEach.call(slides, function (slide, i) {
          slide.classList.toggle('n-bq-slide--active', i === index);
        });
        Array.prototype.forEach.call(dots, function (dot, i) {
          dot.classList.toggle('n-bq-dot--active', i === index);
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      function next() {
        show((current + 1) % slides.length);
      }

      function start() {
        timer = window.setInterval(next, 8000);
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function restart() {
        stop();
        start();
      }

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);

      start();
    });
  }

  function initWteTabs(root) {
    var wraps = root.querySelectorAll('[data-n-wte]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.dataset.nWteInit === 'true') return;
      wrap.dataset.nWteInit = 'true';

      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-n-wte-tab]'));
      if (!tabs.length) return;

      var panels = tabs.map(function (t) {
        var id = t.getAttribute('aria-controls');
        return id ? document.getElementById(id) : null;
      });
      var fill = wrap.querySelector('[data-n-wte-fill]');
      var rail = wrap.querySelector('[data-n-wte-rail]');
      var tabsEl = wrap.querySelector('[data-n-wte-tabs]');
      var active = 0;
      var SLIDE_PX = 32;

      function reduceMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      function select(i, moveFocus) {
        if (i === active || !panels[i]) return;

        var dir = i > active ? 1 : -1;
        var oldPanel = panels[active];
        var newPanel = panels[i];
        var animate = !reduceMotion();

        if (animate && newPanel) {
          newPanel.style.transition = 'none';
          newPanel.style.transform = 'translateX(' + dir * SLIDE_PX + 'px)';
          // force reflow so the browser registers the starting position before animating in
          void newPanel.offsetWidth;
          newPanel.style.transition = '';
        }

        active = i;
        tabs.forEach(function (t, n) {
          var on = n === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panels[n]) panels[n].classList.toggle('n-wte-panel--active', on);
        });

        if (animate) {
          if (oldPanel) oldPanel.style.transform = 'translateX(' + -dir * SLIDE_PX + 'px)';
          if (newPanel) newPanel.style.transform = 'translateX(0)';
        }

        if (fill && tabs.length > 1) {
          fill.style.width = (i / (tabs.length - 1)) * 100 + '%';
        }
        if (moveFocus) tabs[i].focus();
        if (tabsEl && tabsEl.scrollWidth > tabsEl.clientWidth) {
          tabs[i].scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
            behavior: reduceMotion() ? 'auto' : 'smooth'
          });
        }
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i, false); });
        tab.addEventListener('keydown', function (e) {
          var last = tabs.length - 1;
          var next = null;
          if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
          else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = last;
          if (next !== null) {
            e.preventDefault();
            select(next, true);
          }
        });
      });

      function edge() {
        if (!tabsEl || !rail) return;
        var more = tabsEl.scrollWidth - tabsEl.clientWidth - tabsEl.scrollLeft > 4;
        rail.classList.toggle('n-wte-scrollable', more);
      }

      if (tabsEl) {
        tabsEl.addEventListener('scroll', edge, { passive: true });
        window.addEventListener('resize', edge);
        edge();
      }
    });
  }

  function getEvidenceLightbox() {
    var overlay = document.querySelector('[data-n-ev-lightbox-overlay]');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.setAttribute('data-n-ev-lightbox-overlay', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image preview');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div data-n-ev-lightbox-backdrop></div>' +
      '<div data-n-ev-lightbox-panel>' +
        '<button type="button" data-n-ev-lightbox-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<img data-n-ev-lightbox-img alt="">' +
        '<a data-n-ev-lightbox-link target="_blank" rel="noopener" hidden></a>' +
      '</div>';
    document.body.appendChild(overlay);

    var lastFocused = null;

    function close() {
      overlay.hidden = true;
      document.body.classList.remove('n-ev-lightbox-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') close();
    }

    overlay.querySelector('[data-n-ev-lightbox-backdrop]').addEventListener('click', close);
    overlay.querySelector('[data-n-ev-lightbox-close]').addEventListener('click', close);

    overlay.nEvOpen = function (opts, triggerEl) {
      lastFocused = triggerEl || document.activeElement;

      var img = overlay.querySelector('[data-n-ev-lightbox-img]');
      var link = overlay.querySelector('[data-n-ev-lightbox-link]');
      img.src = opts.src;
      img.alt = opts.alt || '';

      if (opts.href) {
        link.href = opts.href;
        link.textContent = opts.label || 'Read the study';
        link.hidden = false;
      } else {
        link.hidden = true;
      }

      overlay.hidden = false;
      document.body.classList.add('n-ev-lightbox-open');
      document.addEventListener('keydown', onKeydown);
      overlay.querySelector('[data-n-ev-lightbox-close]').focus();
    };

    return overlay;
  }

  function initEvidenceLightbox(root) {
    var triggers = root.querySelectorAll('[data-n-ev-lightbox-trigger]');
    if (!triggers.length) return;

    var overlay = getEvidenceLightbox();

    Array.prototype.forEach.call(triggers, function (trigger) {
      if (trigger.dataset.nEvLightboxInit === 'true') return;
      trigger.dataset.nEvLightboxInit = 'true';

      trigger.addEventListener('click', function () {
        overlay.nEvOpen(
          {
            src: trigger.dataset.nEvImg,
            alt: trigger.dataset.nEvAlt,
            href: trigger.dataset.nEvLink,
            label: trigger.dataset.nEvLinkLabel
          },
          trigger
        );
      });
    });
  }

  function initGuaranteeStrike(root) {
    var els = root.querySelectorAll('[data-n-gtr-strike]');
    if (!els.length) return;

    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.nGtrInit === 'true') return;
      el.dataset.nGtrInit = 'true';
      el.classList.add('n-gtr-js');

      if (!('IntersectionObserver' in window)) {
        el.classList.add('n-gtr-play');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              el.classList.add('n-gtr-play');
              observer.unobserve(el);
            }
          });
        },
        { threshold: 0.4 }
      );
      observer.observe(el);
    });
  }

  function initScrollReveal(root) {
    var tracks = root.querySelectorAll('[data-n-sbr-track]');
    if (!tracks.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; // default CSS already renders the final, fully-revealed state

    // The pinned/scroll-jacking effect below assumes a tall desktop
    // viewport. Below the tablet breakpoint the image would otherwise be
    // forced into a fixed 100vh box (object-fit: cover), cropping both the
    // photo and any text baked into it — so on narrow viewports we leave
    // the section in its static, fully-visible CSS layout instead, and
    // bind/unbind the pin effect as the viewport crosses the breakpoint.
    var mqDesktop = window.matchMedia('(min-width: 750px)');

    Array.prototype.forEach.call(tracks, function (track) {
      if (track.dataset.nSbrInit === 'true') return;
      track.dataset.nSbrInit = 'true';

      var imgLayer = track.querySelector('[data-n-sbr-imglayer]');
      var badge = track.querySelector('[data-n-sbr-badge]');
      var scrim = track.querySelector('[data-n-sbr-scrim]');
      var lines = Array.prototype.slice.call(track.querySelectorAll('[data-n-sbr-copy] [data-i]'));
      lines.sort(function (a, b) {
        return Number(a.dataset.i) - Number(b.dataset.i);
      });

      function clamp(v, a, b) {
        a = a === undefined ? 0 : a;
        b = b === undefined ? 1 : b;
        return Math.max(a, Math.min(b, v));
      }

      function stagedReveal(p) {
        var n = lines.length;
        if (!n) return;
        var start = 0.18;
        var span = 0.62;
        lines.forEach(function (el, idx) {
          var a = start + (span / n) * idx;
          var b = a + (span / n) * 0.9;
          var t = clamp((p - a) / (b - a));
          el.style.opacity = t;
          el.style.transform = 'translateY(' + (1 - t) * 40 + 'px)';
        });
      }

      function update() {
        var r = track.getBoundingClientRect();
        var vh = window.innerHeight;
        var total = r.height - vh;
        var p = total > 0 ? clamp(-r.top / total) : 0;

        var blur = (p * 14).toFixed(2);
        var bright = (1 - p * 0.55).toFixed(3);
        var scale = (1 + p * 0.06).toFixed(4);

        if (imgLayer) {
          imgLayer.style.filter = 'blur(' + blur + 'px) brightness(' + bright + ')';
          imgLayer.style.transform = 'scale(' + scale + ')';
        }
        if (badge) badge.style.opacity = String(clamp(1 - p * 2.2));
        if (scrim) scrim.style.opacity = String(clamp((p - 0.05) * 1.6));

        stagedReveal(p);
      }

      function resetInlineStyles() {
        if (imgLayer) {
          imgLayer.style.filter = '';
          imgLayer.style.transform = '';
        }
        if (badge) badge.style.opacity = '';
        if (scrim) scrim.style.opacity = '';
        lines.forEach(function (el) {
          el.style.opacity = '';
          el.style.transform = '';
        });
      }

      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            update();
            ticking = false;
          });
          ticking = true;
        }
      }

      function bindOrUnbind() {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        if (mqDesktop.matches) {
          track.classList.add('n-sbr-js');
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll);
          update();
        } else {
          track.classList.remove('n-sbr-js');
          resetInlineStyles();
        }
      }

      if (mqDesktop.addEventListener) {
        mqDesktop.addEventListener('change', bindOrUnbind);
      } else if (mqDesktop.addListener) {
        mqDesktop.addListener(bindOrUnbind);
      }

      bindOrUnbind();
    });
  }

  var INIT_FNS = [
    initFaqAccordions,
    initPurchaseOptions,
    initGalleryThumbs,
    initVariantPicker,
    initTierOffer,
    initStickyAtc,
    initMediaGallery,
    initBundleAdd,
    initAnnouncementBar,
    initSmoothScroll,
    initQuoteCarousel,
    initWteTabs,
    initEvidenceLightbox,
    initGuaranteeStrike,
    initScrollReveal
  ];

  function initAll(root) {
    // Each initializer runs independently: if one throws (e.g. because of
    // unexpected markup in a section it doesn't recognize), it must not
    // prevent the others — like the evidence-image lightbox — from wiring up.
    INIT_FNS.forEach(function (fn) {
      try {
        fn(root);
      } catch (err) {
        if (window.console && console.error) {
          console.error('[nocturn-pdp] ' + (fn.name || 'init') + ' failed:', err);
        }
      }
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
